// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { NudgeInactiveConfluenceUser } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NudgeInactiveConfluenceUserFlagContainer = lazyForPaint<typeof NudgeInactiveConfluenceUser>(
	() =>
		import(/* webpackChunkName: "async-nudge-inactive-confluence-user-flag" */ './index.tsx').then(
			(module) => module.NudgeInactiveConfluenceUser,
		),
	{ ssr: false },
);

export const AsyncNudgeInactiveConfluenceUserFlagContainer = (): React.JSX.Element => (
	<JSErrorBoundary
		id="nudgeInactiveConfluenceUserFlag"
		packageName="nudgeInactiveConfluenceUser"
		fallback="unmount"
		teamName="cc-flywheel-activation"
	>
		<UFOSegment name="nudge-inactive-confluence-user-flag">
			<Placeholder name="nudge-inactive-confluence-user-flag" fallback={null}>
				<ContextualAnalyticsData sourceType={SCREEN} sourceName="nudgeInactiveConfluenceUserFlag">
					<NudgeInactiveConfluenceUserFlagContainer />
				</ContextualAnalyticsData>
			</Placeholder>
		</UFOSegment>
	</JSErrorBoundary>
);
